"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useHasValueChanged", {
    enumerable: true,
    get: function() {
        return useHasValueChanged;
    }
});
const _react = require("react");
const _lodash = require("lodash");
function useHasValueChanged(value) {
    const prevRef = (0, _react.useRef)(value);
    const hasChanged = !(0, _lodash.isEqual)(prevRef.current, value);
    if (hasChanged) {
        prevRef.current = value;
    }
    return hasChanged;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL3VzZUhhc1ZhbHVlQ2hhbmdlZC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VSZWYgfSBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IGlzRXF1YWwgfSBmcm9tIFwibG9kYXNoXCI7XG5cbi8qKlxuICogQ29tcGFyZXMgYnkgdmFsdWUgKGRlZXAgZXF1YWxpdHkpLlxuICogUmV0dXJucyB0cnVlIG9ubHkgaWYgdGhlIGNvbnRlbnRzIG9mIHRoZSB2YWx1ZSBoYXZlIGNoYW5nZWQuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiB1c2VIYXNWYWx1ZUNoYW5nZWQ8VD4odmFsdWU6IFQpOiBib29sZWFuIHtcbiAgY29uc3QgcHJldlJlZiA9IHVzZVJlZjxUPih2YWx1ZSk7XG4gIGNvbnN0IGhhc0NoYW5nZWQgPSAhaXNFcXVhbChwcmV2UmVmLmN1cnJlbnQsIHZhbHVlKTtcblxuICBpZiAoaGFzQ2hhbmdlZCkge1xuICAgIHByZXZSZWYuY3VycmVudCA9IHZhbHVlO1xuICB9XG5cbiAgcmV0dXJuIGhhc0NoYW5nZWQ7XG59XG4iXSwibmFtZXMiOlsidXNlSGFzVmFsdWVDaGFuZ2VkIiwidmFsdWUiLCJwcmV2UmVmIiwidXNlUmVmIiwiaGFzQ2hhbmdlZCIsImlzRXF1YWwiLCJjdXJyZW50Il0sIm1hcHBpbmdzIjoiOzs7OytCQU9nQkE7OztlQUFBQTs7O3VCQVBPO3dCQUNDO0FBTWpCLFNBQVNBLG1CQUFzQkMsS0FBUTtJQUM1QyxNQUFNQyxVQUFVQyxJQUFBQSxhQUFNLEVBQUlGO0lBQzFCLE1BQU1HLGFBQWEsQ0FBQ0MsSUFBQUEsZUFBTyxFQUFDSCxRQUFRSSxPQUFPLEVBQUVMO0lBRTdDLElBQUlHLFlBQVk7UUFDZEYsUUFBUUksT0FBTyxHQUFHTDtJQUNwQjtJQUVBLE9BQU9HO0FBQ1QifQ==